import globals,{ colors } from '../../styles/globals';
export default (theme) => {
    const { BLUE, WHITE } = colors;
    return {
        ...globals(theme),
        tabs: {
           // marginLeft: '2px',
            minHeight: 'auto',
            '& .MuiTabs-indicator': {
                display: 'none'
            }
        },
        tab: {
            background: '#ccc',
            minHeight: 'auto',
            textTransform: 'capitalize',
            opacity: '1',
            lineHeight: '1.42857',
            borderRadius: '4px 4px 0 0',
            padding: '10px 20px',
            marginRight: '2px',
            minWidth: '141px',
            '&:hover': {
                background: '#ebebeb'
            },
            '& .MuiTab-wrapper': {
                color: '#232323',
                fontSize: '12px',
                '&:hover': {
                    color: BLUE
                }
            },
            '&.Mui-selected': {
                background: BLUE,
                cursor: 'auto',
                '& .MuiTab-wrapper': {
                    color: WHITE,
                    '&:hover': {
                        color: WHITE
                    }
                }
            }
        },
        schedulegrid: {
            marginTop: '10px'
        },
        iggrid: {
            marginTop: '-10px'
        },
        accordian: {
            position: 'fixed',
            bottom: '0px',
            marginRight: '55px',
            marginLeft: '25px',
            '&:before': {
                backgroundColor: '#ddd'
            },
            zIndex: '2'
        },
        accordianExpanded: {
            position: 'fixed',
            bottom: '0px',
            margin: '16px 55px 0px 25px !important',
            '&:before': {
                backgroundColor: '#ddd'
            },
            zIndex: '2'
        },
        span: {
            fontFamily: 'Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '14px'
        },
        accessorySpacing: {
            height: '80px'
        },
        heading: {
            backgroundColor: '#ccc',
            minHeight: '40px !important',
            height: '40px !important'
        }
    // ...globals(theme),
    // blower: {}
    };
};
